<template>
  <v-card
    flat
    outlined
    class="print-view"
    width="325px"
  >
    <v-card-text>
      <v-row
        v-for="(line, idx) in templateLines"
        :key="`template_line_${idx}`"
      >
        <v-col
          v-for="(component, compIdx) in line.components"
          :key="`line_${line.number}_component_${component.componentType}_${compIdx}`"
          class="component-view"
          :class="component.css"
          :cols="12 / line.components.length"
        >
          <v-row
            v-if="component.isImage"
            justify="center"
          >
            <v-col cols="auto">
              <v-img
                contain
                :src="component.src"
                height="300px"
                width="300px"
              />
            </v-col>
          </v-row>
          <div v-else-if="component.isIcon">
            <v-icon large>
              {{ component.icon }}
            </v-icon>
          </div>
          <div v-else>
            <span>{{ component.displayText }}</span>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formTemplate } from "./templateHelper/Helper.js";
export default {
  name: "PrintView",
  props: {
    lines: {
      type: Array,
      required: true
    }
  },
  computed: {
    templateLines() {
      let templateLines = JSON.parse(JSON.stringify(this.lines));
      return formTemplate(templateLines, this.IMAGE_SERVER_API_URL);
    }
  }
};
</script>

<style lang="scss" scoped>
.print-view {
  padding: 10px;

  .component-view {
    padding: 3px 0px;
    white-space: pre; // or pre-line

    // text decoration
    &.dec {
      &--underline {
        text-decoration: underline;
      }
      &--underline_dot {
        text-decoration: underline;
        text-decoration-style: dotted;
      }
    }

    // font family: font-size differs based on font family
    // @todo: identify printer font family and size and adjusted accordingly
    &.ff {
      &--a {
        font-family: "Courier New", Courier, monospace;
        &.fs {
          font-size: 13px;
          &--two_h {
            font-size: 14px;
            transform: scale(1, 2);
          }
          &--two_w {
            font-size: 14px;
            transform: scale(2, 1);
          }
          &--two_w2 {
            font-size: 18px;
            transform: scale(2, 1);
          }
          &--four_sq {
            font-size: 20px;
            transform: scale(1.5, 1.5);
          }
        }
      }

      &--b {
        font-family: Arial, Helvetica, sans-serif;
        &.fs {
          font-size: 13px;
          &--two_h {
            font-size: 14px;
          }
          &--two_w {
            font-size: 16px;
          }
          &--two_w2 {
            font-size: 18px;
          }
          &--four_sq {
            font-size: 20px;
          }
        }
      }
      &--c {
        font-family: "Times New Roman", Times, serif;
        &.fs {
          font-size: 13px;
          &--two_h {
            font-size: 14px;
          }
          &--two_w {
            font-size: 16px;
          }
          &--two_w2 {
            font-size: 18px;
          }
          &--four_sq {
            font-size: 20px;
          }
        }
      }
    }

    // font style
    &.fst {
      &--italic {
        font-style: italic;
      }
    }

    // font weight
    &.fw {
      &--bold {
        font-weight: 600;
      }
    }

    // justification
    &.justify {
      &--ct {
        text-align: center;
      }
      &--lt {
        text-align: start;
      }
      &--rt {
        text-align: end;
      }
    }
  }
}
</style>
